import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import AdminPanel from './components/AdminPanel';
import MainLayout from './components/MainLayout';
import DiscoveryDashboard from './components/DiscoveryDashboard';
import Dashboard from './components/Dashboard';
import SessionDetails from './components/SessionDetails';
import { AuthProvider } from 'react-oidc-context';
import { RequireAuth } from './components/RequireAuth';
import './index.css';

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_m75Y2MuSR",
  client_id: "2ap6gqa4acmorhb3mo2qbrircp",
  redirect_uri: "https://discovery.quantecsystems.com/",
  response_type: "code",
  scope: "email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <Router>
        <Routes>
          <Route path="/" element={<RequireAuth><MainLayout><App /></MainLayout></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><MainLayout><AdminPanel /></MainLayout></RequireAuth>} />
          <Route path="/dashboard" element={<RequireAuth><MainLayout><Dashboard /></MainLayout></RequireAuth>} />
          <Route path="/sessions/:sessionId" element={<RequireAuth><MainLayout><SessionDetails /></MainLayout></RequireAuth>} />
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);
